import { AuthEffects } from './../auth/store/auth.effects';

export const effects = [
  AuthEffects
];
